import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormFeedback } from "reactstrap";

const Error = ({ errorList, current_key }) => {
  if (current_key in errorList) {
    return (
      <FormFeedback className="invalid-feedback-text w-100 d-block">
        {errorList[current_key]}
      </FormFeedback>
    );
  }
  return <></>;
};

Error.propTypes = {
  errorList: PropTypes.object.isRequired,
  current_key: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  errorList: state.errors,
});

export default connect(mapStateToProps)(Error);
